import standardAPI from '@/api/standard_items';

const state = {
  managers: [],
  managers_status: '',
  managers_MetaData: {},
  managers_page: 1,
  managers_perPage: 10,
};

const responseUrl = '/managers';

const getters = {};

const actions = {
  set_current_page ({ commit }, page) {
    commit('SET_CURRENT_PAGE', page);
  },
  set_perPage ({ commit }, max) {
    commit('SET_PER_PAGE', max);
  },
  fetch_managers ({ commit }, getOptions) {
    commit('MANAGERS_REQUEST');
    const preparedOptions = {
      getParams: getOptions.pageOptions,
      url: responseUrl,
      token: getOptions.token,
    };
    return new Promise((resolve, reject) => {
      standardAPI.get_items((response) => {
        try {
          if (response && response.status !== 404) {
            commit('MANAGERS_SUCCESS', response);
            commit('MANAGERS_READY');
            resolve(response);
          } else if (response.status === 404) {
            commit('MANAGERS_READY');
            reject(response);
          } else {
            commit('MANAGERS_ERROR');
            reject(response);
          }
        } catch (error) {
          console.log(error);
        }
      }, preparedOptions);
    });
  },
  add_manager ({ commit, dispatch }, itemData) {
    commit('MANAGERS_REQUEST');
    const preparedData = {
      itemData: itemData,
      url: responseUrl,
    };
    return new Promise((resolve, reject) => {
      standardAPI.add_item(preparedData, (response) => {
        if (response.status === 'created') {
          resolve(response);
        } else {
          commit('MANAGERS_READY');
          reject(response);
        }
      });
    });
  },
  edit_manager ({ commit, dispatch }, itemData) {
    commit('MANAGERS_REQUEST');
    const preparedData = {
      itemData: itemData,
      url: responseUrl + '/',
    };
    return new Promise((resolve, reject) => {
      standardAPI.edit_item(preparedData, (response) => {
        if (response.status === 'updated') {
          resolve(response);
        } else {
          commit('MANAGERS_READY');
          reject(response);
        }
      });
    });
  },
  remove_manager ({ commit, dispatch }, itemData) {
    commit('MANAGERS_REQUEST');
    const preparedData = {
      itemData: itemData,
      url: responseUrl,
    };
    return new Promise((resolve, reject) => {
      standardAPI.remove_items(preparedData, (response) => {
        if (response.status === 'deleted') {
          resolve(response);
        } else {
          commit('MANAGERS_READY');
          reject(response);
        }
      });
    });
  },
  reorder_manager ({ commit, dispatch }, orderData) {
    const preparedData = {
      orderData: orderData,
      url: responseUrl + '/reorder',
    };
    return new Promise((resolve, reject) => {
      standardAPI.reorder_item(preparedData, (response) => {
        if (response.status === 'reorder') {
          resolve(response);
        } else {
          reject(response);
        }
      });
    });
  },
};

const mutations = {
  SET_CURRENT_PAGE: (state, pageNumber) => {
    state.managers_page = pageNumber;
  },
  SET_PER_PAGE: (state, max) => {
    state.managers_perPage = max;
  },
  MANAGERS_READY: (state) => {
    state.managers_status = 'ready';
  },
  MANAGERS_REQUEST: (state) => {
    state.managers_status = 'loading';
  },
  MANAGERS_SUCCESS: (state, response) => {
    if (response && response.meta) {
      state.managers_MetaData.meta = response.meta;
      state.managers_MetaData.links = response.links;
    }
    state.managers = response.data;
    state.managers_status = 'success';
  },
  MANAGERS_ERROR: (state) => {
    state.managers_status = 'error';
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
